module.exports = __webpack_public_path__ + "img/register2.56521c80.svg";